import { Component, Input, OnInit } from '@angular/core';
import { CapitanLocation, MXMerchantUnregisteredTerminal } from '../../../../../../../../../models/location';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';
import { AccountService } from '../../../../../../../../../services/account/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationService } from '../../../../../../../../../services/location/location.service';


@Component({
  selector: 'app-add-mx-merchant-terminal-modal',
  templateUrl: './add-mx-merchant-terminal-modal.component.html',
  styleUrls: ['./add-mx-merchant-terminal-modal.component.css']
})
export class AddMxMerchantTerminalModalComponent implements OnInit {

  @Input() location: CapitanLocation;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public label = '';
  public selectedTerminal: MXMerchantUnregisteredTerminal = null;

  public potentialTerminals: MXMerchantUnregisteredTerminal[] = null;

  public loadingPotentialTerminals = true;
  public loadingSubmit = false;
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }

    this.loadPotentialTerminals();
  }

  public allInputsProvided(): boolean {
    return (!!this.label && !!this.selectedTerminal);
  }

  public handleSave() {
    if (!this.allInputsProvided()) { return; }

    this.loadingSubmit = true;

    this.locationService
      .addMXMerchantTerminal(
        this.selectedTerminal.terminal_id,
        this.label,
        this.location.id
      )
      .then(createdReader => {
        this.savedCallback({
          text: createdReader.label + ' added successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to add this payment terminal.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  private loadPotentialTerminals() {
    this.loadingPotentialTerminals = true;

    this.locationService
      .getUnregisteredMXMerchantTerminals(this.location.payment_processor_connection_id)
      .then(potentialTerminals => {
        this.potentialTerminals = potentialTerminals;
      })
      .catch(reason => {
        this.serverError = reason.error;
      })
      .finally(() => { this.loadingPotentialTerminals = false; });
  }
}
